import './LanguageSelector.css'
import { useTranslation } from 'react-i18next';
import { ServiceFactory } from '../../Api/Services/ServiceFactory';
import { useToast } from '../../components/ToastContext/ToastContext';

function LanguageSelector() {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const {showToast} = useToast();

  let isReinitializing = false;

  const changeLanguage = async (lng) => {

    if (isReinitializing) return;
    isReinitializing = true;

    try {
      await i18n.changeLanguage(lng);
      await ServiceFactory.reinitialize((key, options) => i18n.t(key, options));
    } catch (error) {
      showToast(t('error:reseterror', 'error'));
      throw (error); // gestito nel global error
    } finally {
      isReinitializing = false;
    }
  };

  return (
    <div>
      <select className='div-language' onChange={(e) => changeLanguage(e.target.value)} defaultValue={i18n.language}>
        <option className='options-language' value="it">Italiano</option>
        <option className='options-language' value="en">English</option>
      </select>
    </div>
  );
}

export default LanguageSelector;